import React, { memo } from 'react';
import CloudWatchDashboard from './CloudWatchDashboard';
import { getRabbitChurnRatesMetrics } from './metrics/rabbitChurnRatesMetrics';
import { Broker } from '@amzn/amazonmq-opsconsole-client';

type Props = {
    broker: Broker,
}

const RabbitChurnAndRatesTab : React.FC<Props> = ({broker}) => {
    let widgets = getRabbitChurnRatesMetrics(broker);

    return (
        <div>
            <CloudWatchDashboard
                broker={broker}
                layoutType='automatic'
                widgetsPerRow={2}
                serviceAccountId={broker.summary.serviceAccountId}
                widgets={widgets}
            /> 
        </div>
    )
}

export default memo(RabbitChurnAndRatesTab);